import type { FaireProductEntity } from "../../entity_types/product";

export const p_7av8cdsyus: FaireProductEntity = {
  token: "p_7av8cdsyus",
  type: "product",
  name: "Christmas Butter Bar Slow-Rising Squishy – 12-Piece Display Box",
  brandToken: "b_qg29vqjs6u",
  brandName: "Accessiorie (We Pay All Duties)",
  imageUrl:
    "https://cdn.faire.com/fastly/c8f82ac16e74c04704b57fdc0ceb84b8dc2f4dfe321105ad21c58cf0a2f1844e.webp",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c4385dc80ae6754878d958d12fcaf2425cca999e3190ebc0d3c0a966715d023a.webp",
    "https://cdn.faire.com/fastly/173328d271fbccd801a4d9813ba1b2d2fb3a5b57df9a2e495800f43811529658.webp",
    "https://cdn.faire.com/fastly/df886fe39cc86b9e4643d4f98940f575be5a2a89b385d1dd276deb4cb0944c43.webp",
  ],
  priceDollars: 3.5,
  description:
    "Celebrate the holiday season with these colorful Christmas-themed butter bar squishies.\nEach squishy features a soft, squeezable texture with a slow-rising effect for satisfying stress relief.\nThe assorted Christmas prints include Santa, reindeer, snowflakes, gifts, Christmas trees, and festive greetings.\nEach piece comes individually packaged in a clear OPP bag for clean and convenient display.\nPacked in a festive 12-piece retail display box, making it suitable for holiday gifts, party favors, stocking stuffers, and impulse purchases.\nAssorted colors and designs are included in each display box.",
  tags: [],
  msrpDollars: 7,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:48:15.845Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
